import Vue from 'vue'
import { BSpinner as Spinner } from 'bootstrap-vue'

import Address from './Address'
import IconCheck from './icons/Check'
import IconX from './icons/X'
import Layout from './Layout'
import LayoutDefault from './LayoutDefault'
import LayoutError from './LayoutError'
import LayoutSingle from './LayoutSingle'
import LayoutTwoColumn from './LayoutTwoColumn'
import Ribbon from './Ribbon'
import Time from './Time'
import Timeline from './Timeline'
import TimelineItem from './TimelineItem'
import nl2br from './nl2br'

const auto =
{
	'e-address':       Address,
	'e-icon-check':    IconCheck,
	'e-icon-x':         IconX,
	'e-layout':        Layout,
	'e-ribbon':        Ribbon,
	'e-time':          Time,
	'e-timeline':      Timeline,
	'e-timeline-item': TimelineItem,
	'l-default':       LayoutDefault,
	'l-error':         LayoutError,
	'l-single':        LayoutSingle,
	'l-two-column':    LayoutTwoColumn,
	'spinner':         Spinner,

	nl2br,
}

Object.keys(auto).forEach(key => Vue.component(key, auto[key]))

export
{
	Address,
	IconCheck,
	IconX,
	Layout,
	LayoutDefault,
	LayoutError,
	LayoutSingle,
	LayoutTwoColumn,
	Ribbon,
	Spinner,
	Time,
	Timeline,
	TimelineItem,
	nl2br,
}